import moment from 'moment';
import React from 'react';
import ActionsFactory from 'src/actions/ActionsFactory';
import NavActions from 'src/actions/NavActions';
import AppRoutes from 'src/AppRoutes';
import Util from 'src/Util';
import type {HistoryItem as HistoryItemType} from 'src/types/TransactionDetail';
import AccountConstants from 'src/constants/AccountConstants';
import AccountStore from 'src/stores/AccountStore';
import HistoryItem from '../../elements/account/HistoryItem';
import {FlashList} from '@shopify/flash-list';

export const filterTypes = {
  all: '',
  funding: AccountConstants.FUNDING_TYPE,
  purchases: AccountConstants.SALE_TYPE,
};

type AccountHistoryListProps = {
  filterType: string;
};

type HistoryState = {
  isRefreshing: boolean;
  historyItems: any;
  page: number;
};
export default class AccountHistoryList extends React.Component<
  AccountHistoryListProps,
  HistoryState
> {
  changeEvent = null;
  started = moment();

  constructor(props: AccountHistoryListProps) {
    super(props);
    this._onChange = this._onChange.bind(this);
    this.renderItem = this.renderItem.bind(this);
    this.handleLoadMore = this.handleLoadMore.bind(this);
    this._onRefresh = this._onRefresh.bind(this);

    const historyItems = AccountStore.getPurchaseHistory(this.props.filterType);
    this.state = {
      isRefreshing: false,
      historyItems,
      page: 1,
    };
  }

  componentDidUpdate(prevProps: AccountHistoryListProps) {
    if (prevProps.filterType === this.props.filterType) {
      return;
    }

    const data = AccountStore.getPurchaseHistory(this.props.filterType);
    this.setState({
      historyItems: data,
    });
  }

  componentDidMount() {
    AccountStore.clearPurchaseHistory();
    ActionsFactory.getAccountActions().loadPurchaseHistory(
      AccountStore.getAccountId(),
      this.state.page,
    );
    AccountStore.addHistoryChangedListener(this._onChange);
  }

  componentWillUnmount() {
    AccountStore.removeHistoryChangedListener(this._onChange);
  }

  static onItemPress(historyItem: HistoryItemType, inSettings: boolean) {
    if (
      historyItem.Type === AccountConstants.SALE_TYPE ||
      historyItem.Type === AccountConstants.FUNDING_TYPE ||
      historyItem.Type === AccountConstants.REFUND_TYPE ||
      historyItem.Type === AccountConstants.REDEMPTION_TYPE
    ) {
      if (inSettings) {
        NavActions.push(AppRoutes.PurchaseHistoryDetail, {
          transactionId: historyItem.Id,
          transactionType: historyItem.Type,
          transactionDate: historyItem.TransDate,
          transactionCurrency: historyItem.currency,
        });
      } else {
        NavActions.navigate(AppRoutes.PurchaseHistoryDetail, {
          transactionId: historyItem.Id,
          transactionType: historyItem.Type,
          transactionDate: historyItem.TransDate,
          transactionCurrency: historyItem.currency,
        });
      }
    } else if (
      historyItem.Type === AccountConstants.REFERRAL_TYPE ||
      historyItem.Type === AccountConstants.REFERRAL_SIGNUP_TYPE
    ) {
      NavActions.navigate(AppRoutes.ReferralSummary, {
        historyItem,
      });
    }
  }

  async _onChange() {
    await Util.delayForUX(this.started);
    this.setState({
      isRefreshing: false,
      historyItems: AccountStore.getPurchaseHistory(this.props.filterType),
    });
  }

  _onRefresh(page: number) {
    this.started = moment();
    ActionsFactory.getAccountActions().loadPurchaseHistory(
      AccountStore.getAccountId(),
      page,
    );
    this.setState({
      isRefreshing: true,
      page,
    });
  }

  handleLoadMore() {
    const fullItems = AccountStore.getPurchaseHistory('');
    const lastItem = fullItems[fullItems.length - 1];

    let hasMore = false;
    if (lastItem) {
      hasMore = !lastItem.lastItem;
    }

    if (hasMore && !this.state.isRefreshing) {
      this._onRefresh(this.state.page + 1);
    }
  }

  renderItem({item, index}) {
    return (
      <HistoryItem
        {...this.props}
        historyItem={item}
        onPress={(historyItem) =>
          AccountHistoryList.onItemPress(historyItem, true)
        }
        index={index}
      />
    );
  }

  render() {
    return (
      <FlashList
        estimatedItemSize={80}
        onRefresh={() => this._onRefresh(1)}
        data={this.state.historyItems}
        refreshing={this.state.isRefreshing}
        renderItem={this.renderItem}
        onEndReached={this.handleLoadMore}
        onEndReachedThreshold={0.5}
      />
    );
  }
}
